module.exports = __webpack_public_path__ + "static/EmilyIsAway1-66312ae529639ae104e3d383e9ea72d4.png";